import { userModel } from 'common/api/models';

/**
 * @param raw
 * @return {commentModel.type}
 */
export const commentModel = (raw) => {
  return raw
    ? {
        id: raw.id || null,
        content: raw.content || '',
        createdAt: raw.createdAt || null,
        updatedAt: raw.updatedAt || null,
        user: userModel(raw.user),
      }
    : null;
};

/**
 * @typedef {{
 *  id: number,
 *  content: string,
 *  createdAt: number,
 *  updatedAt: number,
 *  user: userModel.type,
 * }}
 */
commentModel.type = null;
